export default __webpack_public_path__ + "static/media/q-over.4913ac48.svg";